import { useEffect, useState } from "react";

const PromoImageContainer = ({
  image,
  mobileImage,
  title,
  text,
  button,
  buttonUrl,
  urlPromoCode,
  isMobile,
}) => {
  const [useDesktopImage, setUseDesktopImage] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      // Adjusted breakpoint logic for tablet and small desktop behavior
      if (width >= 750) {
        setUseDesktopImage(true);
      } else if (width <= 769 && !isMobile) {
        setUseDesktopImage(true);
      } else {
        setUseDesktopImage(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);
  const getPromoUrl = (url, urlPromoCode) => {
    if (!urlPromoCode) return url;
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set("promo", urlPromoCode);
    return urlObj.toString();
  };

  return (
    <div className="promo-image-container">
      <img
        src={useDesktopImage || !isMobile ? image.url : mobileImage.url}
        className="promo-banner-image"
        alt={useDesktopImage || !isMobile ? image.alt : mobileImage.alt}
      />
      <div className="promo-image-overlay">
        <h2 className="promo-image-title">{title}</h2>
        <p className="promo-image-text">{text}</p>
        <a
          href={getPromoUrl(buttonUrl, urlPromoCode)}
          className="promo-image-button"
        >
          {button}
        </a>
      </div>
    </div>
  );
};

export default PromoImageContainer;
